import { type FunctionComponent } from 'react';
import { configureRoute } from '../../../utils/routes/configure-route';
import { PageContainer } from '../../components/common-components/page/page-container/page-container.component';
import { RebateCenterWidget } from '../../components/rebates/widgets/rebate-center-widget/rebate-center-widget.component';
import { DEFAULT_META_DESCRIPTION, FEATURE_FLAGS } from '../../constants/general';
import { REBATES_LINK, REBATES_MANUFACTURER_LINK } from '../../constants/links';
import { useTrackPageView } from '../../hooks/analytics/analytics.hooks';
import { useFeature } from '../../hooks/features/features.hooks';
import { useRouterLocation } from '../../hooks/routing/location.hook';
import { LandingPage } from '../landing/landing.page';

export const RebateCenterPage: FunctionComponent = () => {
	useTrackPageView({ pageName: 'rebate-center' }, { page: 'rebate-center' });
	const { pathname } = useRouterLocation();
	const ecoRebatesWidgetsActive = useFeature(FEATURE_FLAGS.ECOREBATES_WIDGETS);
	if (ecoRebatesWidgetsActive && pathname === REBATES_LINK) {
		return (
			<PageContainer canonicalURL={REBATES_LINK} pageTitle="Rebate Center" metaDescription={DEFAULT_META_DESCRIPTION}>
				<RebateCenterWidget />
			</PageContainer>
		);
	}
	return <LandingPage />;
};

export const RoutedRebateCenter = configureRoute({ path: [REBATES_LINK, REBATES_MANUFACTURER_LINK] }, RebateCenterPage);
